import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './Guards/auth.guard';
import { BasicAuthInterceptor} from './Interceptors/basic-auth.interceptor';
import { PopoverModule } from "ngx-smart-popover";

import { KPISResolver } from './Resolvers/admin/kpis-data-resolver';
import { FAQResolver } from './Resolvers/admin/faq-data-resolver';
import { DOCsResolver } from './Resolvers/admin/documents-data-resolver';
import { FAQTypeResolver } from './Resolvers/admin/faq-types-resolver';
import { GPWGoalsResolver } from './Resolvers/admin/gpw-goals-resolver';
import { GPWOutcomesResolver } from './Resolvers/admin/gpw-outcomes-resolver';
import { GPWOutputsResolver } from './Resolvers/admin/gpw-outputs-resolver';
import { GPWReferencesResolver } from './Resolvers/admin/gpw-references-resolver';
import { KpiDefinationLevelsResolver } from './Resolvers/admin/kpi-def-resolver';
import { KpiThresholdResolver } from './Resolvers/admin/kpi-threshold-resolver';
import { GlossaryResolver } from './Resolvers/admin/glossaries-data-resolver';
import { UsersResolver } from './Resolvers/admin/user-data.resolver';
import { UsersAllResolver } from'./Resolvers/admin/users.resolver';
import { MyKpisResolver } from './Resolvers/website/my-kpi-data-resolver';
import { RedirectComponent } from './Modules/redirect/redirect.component';
import { BCenterResolver } from './Resolvers/website/budget-center-data-resolver';
import { ActiveDefinitionsResolver } from './Resolvers/admin/active-definitions-data.resolver';
import { ActiveThresholdResolver } from './Resolvers/admin/active-threshold-data.resolver';
import { ActiveOutputsResolver } from './Resolvers/admin/active-outputs-data.resolver';
import { ActiveKPISResolver } from './Resolvers/admin/active-kpis-data.resolver';
import { ActiveGoalsResolver } from './Resolvers/admin/active-goals-data.resolver';
import { ActiveOutcomesResolver } from './Resolvers/admin/active-outcomes-data.resolver';
import { ActiveReferencesResolver } from './Resolvers/admin/active-references-data.resolver';
import { ActiveFAQResolver } from './Resolvers/website/active-faqs-data-resolver';
import { ActiveGlossaryResolver } from './Resolvers/website/active-glossary-data-resolver';
import { KPIStatusResolver } from './Resolvers/website/kpi-statuses-data-resolver';
import { AdminGuard } from './Guards/admin.guard';
import { BCFocusResolver } from './Resolvers/website/bc-focus-data-resolver';
import { ActiveKPISListResolver } from './Resolvers/admin/active-kpis-list-data.resolver';
import { ContactUsMessagesResolver } from './Resolvers/admin/contact-us-messages.resolver';
import { ReportsResolver } from './Resolvers/website/reports-data-resolver';
import { RegionalKPISResolver } from './Resolvers/admin/regional-kpis-data-resolver';
import { MyRegionalKpisResolver } from './Resolvers/website/my-regional-kpi-data-resolver';

const appRoutes: Routes = [
  {
    path:'',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path:'admin', 
    loadChildren: './Modules/admin/admin.module#AdminModule',
    canActivate: [AdminGuard, AuthGuard]
  },
  {
    path:'home', 
    loadChildren: './Modules/website/website.module#WebsiteModule',
    // canActivate: [AuthGuard]
  },
  {path:'redirect', component: RedirectComponent},
  {
    path:'**',
    redirectTo:'home'
  }
]


@NgModule({
  declarations: [
    AppComponent,
    RedirectComponent,   
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot({
      closeButton:true,
      disableTimeOut:true
    }), // ToastrModule added
    PopoverModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.rotatingPlane,
      backdropBackgroundColour: 'rgba(0,0,0,0.3)', 
      backdropBorderRadius: '0px',
      primaryColour: '#438EB9', 
      // secondaryColour: '#438EB9', 
      // tertiaryColour: '#438EB9',
      fullScreenBackdrop:true
  }),
  ],
  providers: [KPISResolver, FAQResolver, DOCsResolver, FAQTypeResolver, GPWGoalsResolver, 
    GPWOutcomesResolver, GPWOutputsResolver, GPWReferencesResolver, KpiDefinationLevelsResolver,
    KpiThresholdResolver, GlossaryResolver, MyKpisResolver, UsersResolver,UsersAllResolver, BCenterResolver,
    ActiveDefinitionsResolver, ActiveThresholdResolver, ActiveOutputsResolver, ActiveKPISResolver,
    ActiveGoalsResolver, ActiveOutcomesResolver, ActiveReferencesResolver, ActiveFAQResolver,
    ActiveGlossaryResolver, KPIStatusResolver, BCFocusResolver, ActiveKPISListResolver, 
    ContactUsMessagesResolver,ReportsResolver, RegionalKPISResolver, MyRegionalKpisResolver,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  exports:[RouterModule]
})
export class AppModule {
}
